import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getMyTasks } from '../../../api/safetyRounds';
import { useChecklistLanguage } from './usePlanQueries';

export const taskKeys = {
  mine: (language: string) => ['safety-rounds', 'tasks', language] as const,
};

/**
 * «Mine oppgaver» for the safety representative and the general manager. The menu counts come
 * from here too, so they follow every change the user makes in safety rounds.
 */
export const useMyTasksQuery = (enabled = true) => {
  const language = useChecklistLanguage();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    return queryClient.getMutationCache().subscribe((event) => {
      if (event.type === 'updated' && event.action.type === 'success')
        void queryClient.invalidateQueries({ queryKey: ['safety-rounds', 'tasks'] });
    });
  }, [enabled, queryClient]);
  return useQuery({ queryKey: taskKeys.mine(language), queryFn: () => getMyTasks(language), enabled });
};
